export async function asRows(promise) {
  try {
    const response = await promise
    const body = response?.data
    if (Array.isArray(body)) return body
    if (body && Array.isArray(body.data)) return body.data
    if (body && typeof body === 'object') return [body]
    return []
  } catch {
    return []
  }
}

export async function asOptions(promise, mapFn) {
  const rows = await asRows(promise)
  return rows.map(mapFn).filter((option) => option?.value != null && option.value !== '')
}

export async function firstOption(promise, mapFn) {
  const options = await asOptions(promise, mapFn)
  return options[0] || null
}
